import React from "react";
import { policies } from "../data/wholesaleProducts";
import "../style/privacy.scss";
export default function Policy({ active, openPolicy }) {
  const data = policies[active];
  return (
    <main className="policy-page">
      <nav className="policy-nav" aria-label="Policy pages">
        {Object.keys(policies).map((key, i) => (
          <button
            className={active === key ? "active" : ""}
            onClick={() => openPolicy(key)}
            key={key}
          >
            <small>0{i + 1}</small>
            {policies[key].nav}
          </button>
        ))}
      </nav>
      <article>
        <header>
          <span>{data.kicker}</span>
          <h1>{data.title}</h1>
          <p>{data.intro}</p>
          <div>
            <b>PLAIN-LANGUAGE POLICY</b>
            <b>REVIEWED OCTOBER 2026</b>
          </div>
        </header>
        {data.sections.map(([title, body], i) => (
          <section key={title}>
            <small>{String(i + 1).padStart(2, "0")}</small>
            <div>
              <h2>{title}</h2>
              <p>{body}</p>
            </div>
          </section>
        ))}
        <footer>
          <span>NEED A SPECIFIC ANSWER?</span>
          <h2>Talk to our care team.</h2>
          <p>
            Include your order number and what you need help with. A real
            person replies within one business day.
          </p>
          <a href="mailto:hello@delmorian.example">HELLO@DELMORIAN.EXAMPLE ↗</a>
        </footer>
      </article>
    </main>
  );
}


